import React, {useEffect, useState} from 'react';
import Alert from '@amzn/meridian/alert';
import Heading from '@amzn/meridian/heading';
import {FormattedMessage, useIntl} from 'react-intl';
import {showUnAuthorizedAlert} from '../config/nonSignedInPageRoutes';
import {useAuthorisedEntities,} from '@amzn/carrierlogistics-commons/dist/hooks/authorisation/index';
import {hasAccessToAtleastOneTerm} from "../utils/authorizedPageUtils";
import {useLocation} from "react-router-dom";
import isEmpty from "lodash/isEmpty";

const UnAuthorizedAlert = () => {
    const {pathname} = useLocation();
    const {formatMessage} = useIntl();
    const authorizedEntities = useAuthorisedEntities()
    const [shouldHideAlert, setShouldHideAlert] = useState(true);
    useEffect(() => {
        // On page load authorizedEntities will be empty by default.
        if( isEmpty(authorizedEntities) ) return
        setShouldHideAlert(hasAccessToAtleastOneTerm(authorizedEntities))
    }, [authorizedEntities]);
    const shouldShowAlert = showUnAuthorizedAlert.some((path) => pathname.includes(path));

    if (shouldHideAlert || !shouldShowAlert) return null;

    return (<Alert
        type="warning"
        size="large"
        title={formatMessage({id: 'unauthorized.title'})}
        onClose={() => setShouldHideAlert(true)}
    >
        <Heading>
            <FormattedMessage id="unauthorized.message"/>
        </Heading>
    </Alert>);
};

export default UnAuthorizedAlert;